export default __webpack_public_path__ + "static/media/login.5b5e053e.jfif";